import css from 'styled-jsx/css'

import { colors } from '../../../theme'


export default css`
  :global(.slide .text, .slide .title, .slide figcaption) {
    color: ${colors.pureWhite};
  }
`
